module.exports = __webpack_public_path__ + "img/dot-done-min.b64b89ca.png";